import React, {forwardRef, useEffect, useRef, useState} from 'react';
import './HotspotMap.sass'

const HotspotMap = forwardRef(({data, style, hotspotStyle, selected}, ref) => {

    useEffect(() => {

    }, []);

    const onSelect = (event) => {
        let hs = event.currentTarget;
        selected(event)
    }
    
    const getTarget = (event) =>{
        console.log("HotspotMap getTarget(",event,")");
        console.log("   event.target.class: ", event.target.className);
        if(event.target.className==="map-hotspot"){
            selected(event);
        }
        else
        {
            selected(null);
        }
    }

    const captureMouse = (event) => {
        //console.log("   event.clientX,event.clientY: ", event.clientX,event.clientY);
    }

    return (
        <div className={"HotspotMap"}
             ref = {ref}
             style={style || {}}
             onClick = {(event)=>{getTarget(event)}}
             onMouseMove={(event) => {
                 captureMouse(event)
             }}>
            {data.background &&
            <img src={data.background}/>}
            {
                data.hotspots.map((hs, index) =>
                    (<div className={"map-hotspot"}
                          id={hs.id}
                          key={"hotspot" + index}
                          style={hs.style}/>)
                )
            }

        </div>
    );
})

export default HotspotMap;